export default __webpack_public_path__ + "f6e2da6558cba0190d942c08b0679a97.png";